import { QueryObserverOptions, useQuery } from "react-query";
import { Card } from "../@types";
import { APIError, APIResponse, API_URL, get } from "../api";

const NO_CARD_MESSAGE = "You have not added a card";

function useCard(options?: QueryObserverOptions<APIResponse<Card>, APIError>) {
  const {
    data: card,
    isError,
    error,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery<APIResponse<Card>, APIError>(
    "card",
    async () => {
      try {
        return await get(API_URL + "/account/banking/card", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
      } catch (e) {
        if (e instanceof Error && e.message === NO_CARD_MESSAGE) {
          return { data: undefined, status: true } as APIResponse<Card>;
        }
        throw e;
      }
    },
    {
      retry: (_, error) => error?.message !== NO_CARD_MESSAGE,
      ...options,
    }
  );

  return {
    card,
    isError,
    error,
    isLoading,
    refetch,
    isRefetching,
  };
}

export default useCard;
